import { AnfrageListDisplayModel } from '@/api/models/ace/xFound/Portal/Core/CAQ/Models/anfrage-list-display-model';
import { PortalContextService } from '@/core/services/portal-context.service';
import { StateService } from '@/core/services/state.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { GlobalEnumsAceJaNein, LocalizedTextDisplayModel, PortalkonfigurationDisplayModel } from '@/api/model-index';
import { I18nService } from '@/core/services/i18nService';
import { AnfrageLiveSharingService } from '@/core/services/anfrage-live-sharing.service';

@Component({
  selector: 'anfrage-info',
  templateUrl: './anfrage-info.component.html',
  styleUrls: ['./anfrage-info.component.scss']
})
export class AnfrageInfoComponent implements OnInit {

  public portalkonfiguration: PortalkonfigurationDisplayModel;

  public get showAnfrageInfo() {
    return this.stateService.showAnfrageInfo;
  }

  public get anfrage(): AnfrageListDisplayModel | null {
    return this.portalContextService.CurrentAnfrage
  }

  public get title(): string {
    if(!this.anfrage)
      return "";

    var projektTitel = this.anfrage.name ?? this.languageservice.instant('newAnfrageTitle');

    return this.anfrage.nummer + " - " + projektTitel;
  }

  public get ausschreibung(): string {
    if(!this.anfrage)
      return "";

    return this.anfrage.ausschreibungName ?? this.languageservice.instant('undefinedText');
  }

  public get phase(): string {
    if(!this.anfrage)
      return "";

    let title: LocalizedTextDisplayModel | undefined = this.languageservice.getCurrentLocalizedTextDisplayModel(this.anfrage.phase?.name);
    return title?.text ?? this.languageservice.instant('undefinedText');
  }

  public get bereich(): string {
    if(!this.anfrage)
      return "";

    return this.anfrage.foerderprogrammName ?? this.languageservice.instant('undefinedText');
  }

  public get FreigabeAktiviert(): boolean{
    return this.portalkonfiguration.freigabeDeaktivieren != GlobalEnumsAceJaNein.Ja;
  }

  constructor(protected route: ActivatedRoute, protected stateService: StateService, protected portalContextService: PortalContextService, protected languageservice: I18nService, protected anfrageLiveSharingService: AnfrageLiveSharingService) {
  }

  ngOnInit(): void {
    this.portalkonfiguration = this.route.snapshot.data.portalkonfiguration;
  }

  openFreigebenDialog() {
    this.anfrageLiveSharingService.openFreigebenDialog(this.portalContextService.CurrentAnfrage.id, this.portalContextService.CurrentAnfrage.objektTyp!, null, true);
  }
}
